export class ConversorJuros {
  private static readonly FATOR = 1
  private static readonly DIA = 1
  private static readonly DIAS_DO_ANO = 365
  private static readonly DECIMAIS = 18

  static converterTaxaDeJurosAnualParaDiaria(taxaAnual: number) {
    const taxaDiaria = (this.FATOR + taxaAnual / 100) ** (this.DIA / this.DIAS_DO_ANO) - this.FATOR
    return taxaDiaria
  }
}
